import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';

export const useAmplify = () => {
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [isSignedIn, setIsSignedIn] = useState(
    localStorage.getItem('isSignedIn'),
  );

  const signOut = async () => {
    try {
      await Auth.signOut();
      localStorage.clear();
      setIsSignedIn(false);
      setUser(null);
    } catch (err) {
      throw new Error(err);
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = await Auth.currentSession();
        const { idToken } = session;

        const user = {
          id: idToken.payload.sub,
          jwt: idToken.jwtToken,
          firstName: idToken.given_name,
          lastName: idToken.family_name,
        };

        localStorage.setItem('isSignedIn', true);
        localStorage.setItem('user', JSON.stringify(user));
        setIsSignedIn(true);
        setUser(user);
      } catch (err) {
        signOut();
        console.error(err);
      }
    };

    if (!user) {
      checkAuth();
    }
  }, [user]);

  const signUp = async (email, password, firstName, lastName) => {
    try {
      await Auth.signUp({
        username: email,
        password,
        attributes: {
          email,
          given_name: firstName,
          family_name: lastName,
        },
        autoSignIn: {
          enabled: true,
        },
      });
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const verify = async (email, code) => {
    try {
      await Auth.confirmSignUp(email, code);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const resendConfirmationCode = async (email) => {
    try {
      await Auth.resendSignUp(email);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const signIn = async (username, password) => {
    try {
      const cogUser = await Auth.signIn({ username, password });

      const {
        signInUserSession: { idToken },
        attributes,
      } = cogUser;

      const user = {
        id: attributes.sub,
        jwt: idToken.jwtToken,
        firstName: attributes.given_name,
        lastName: attributes.family_name,
      };

      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('isSignedIn', true);
      setIsSignedIn(true);
      setUser(user);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const forgotPassword = async (email) => {
    try {
      await Auth.forgotPassword(email);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  const resetPassword = async (email, code, password) => {
    try {
      await Auth.forgotPasswordSubmit(email, code, password);
    } catch (err) {
      throw new Error(err.message);
    }
  };

  return {
    user,
    isSignedIn,
    signIn,
    signOut,
    signUp,
    verify,
    resendConfirmationCode,
    forgotPassword,
    resetPassword,
  };
};
